import React, {useMemo} from 'react';

import {Skeleton, SkeletonItem} from 'src/components/skeleton';
import {useLicenseTypes} from 'src/hooks/dictionaries';

import Button from '@pb/kit-component-button';
import {Group} from '@pb/kit-component-group';


import type {LicenseType} from 'src/openapi/admin/models/LicenseType';

type Props = {
    licenseType?: LicenseType,
    isDefaultModules: boolean,
    loading: boolean,
    disabled?: boolean,
    onReset: () => void,
};

const ResetLimitsSkeleton = () => (
    <Group>
        <SkeletonItem width={156} height={32}/>
        <SkeletonItem width={400} height={18}/>
    </Group>
);

export const ResetDefaultModulesSection = (props: Props) => {
    const {licenseType, isDefaultModules, loading, onReset, disabled} = props;
    const {getLicenseTypeByCode} = useLicenseTypes();

    const description = useMemo(() => (
        licenseType ? getLicenseTypeByCode(licenseType) : ''
    ), [licenseType, getLicenseTypeByCode]);

    return (
        <Skeleton view={<ResetLimitsSkeleton/>} shown={loading || !description}>
            <Group>
                <Button
                    variant="Type.SECONDARY"
                    disabled={disabled || isDefaultModules}
                    onClick={onReset}>
                    Use default settings
                </Button>
                {isDefaultModules ? (
                    <div>
                        <>Currently using default settings for <b>{description}</b> license type.</>
                    </div>
                ) : (
                    <div>
                        <b>Currently using custom settings.</b> Reset to defaults for
                        the <b>{description}</b> license type.
                    </div>
                )}
            </Group>
        </Skeleton>
    );
};
